import {RoleDto} from "@reside/reside-api-app";

export const isClerk = user => user.role.name === RoleDto.NameEnum.CLERK;
export const isResideAdmin = user =>
  user.role.name === RoleDto.NameEnum.RESIDE_ADMIN;
